import React, {useState} from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {NotePage} from "../pages/NotePage"
import {getLocalStorageItem, getPathAndQueryParams, objectLang} from "../functions"

export const ViewWindowQuestion = ({object, data}) => {

    const [show, setShow] = useState(true)

    const l = objectLang().language.lang

    const clickHandler = (str) => {
        if (!str) {
            setShow(false)
            return (<NotePage noteObject={object}/>)
        } else if (str.includes('replaceTo') && str.split('replaceTo ')[1]) {
            return window.location.replace(str.split('replaceTo ')[1])
        } else if (str === 'replaceToBack') {
            const pathBack = getLocalStorageItem('pathBack')
            return window.location.replace(pathBack)
        } else if (str === 'saveNote') {
            return window.location.replace(`/${l}/note/save/${object._id}`)
        } else if (str === 'saveNewNote') {
            return window.location.replace(`/${l}/note/save/new`)
        } else if (str === 'tapeNoteName') {
            setShow(false)
            return (<NotePage noteObject={object} />)
        } else if (str === 'updateLink') {
            return window.location.replace(`/${l}/link/save/${object._id}`)
        } else if (str === 'updateFolder') {
            return window.location.replace(`/${l}/folder/save/${object._id}`)
        } else {
            return window.location.replace(getPathAndQueryParams())
        }
    }

    let classCancel = ""
    if (data.btnCancel === "off") {
        classCancel = "d-none"
    }

    return (
        <>
            <Modal id={"quest-window"} show={show}>
                <Modal.Header>
                    <Modal.Title className={'w-100'}>{data.title}</Modal.Title>
                    {/*<Button className={'ms-2'}*/}
                    {/*    variant={"close"}*/}
                    {/*    onClick={closeHandler}>*/}
                    {/*</Button>*/}
                </Modal.Header>
                <Modal.Body>{data.desc}</Modal.Body>
                <Modal.Footer>
                    <Button
                        variant={data.btnOKColor}
                        onClick={() => {
                            clickHandler(data.clickOK)
                        }}>
                        {data.btnOK}
                    </Button>
                    <Button
                        variant={data.btnCancelColor}
                        className={classCancel}
                        onClick={() => {
                            clickHandler(data.clickCancel)
                        }}>
                        {data.btnCancel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}